// @flow

import {
  GetReportingReferralDetailsDefaultReports,
  GetReportingReferralDetailsDefaultReportsSuccess,
  GetReportingReferralDetailsDefaultReportsError,
  GetReportingReferralDetailsMyReports,
  GetReportingReferralDetailsMyReportsSuccess,
  GetReportingReferralDetailsMyReportsError,
  GetReportingReferralDetailsReport,
  GetReportingReferralDetailsReportSuccess,
  GetReportingReferralDetailsReportError,
  GetReportingReferralDetailsChartsSuccess,
  GetReportingReferralDetailsCharts,
  GetReportingReferralDetailsChartsError,
  GetReferralDetailsFiltersSchema,
  GetReferralDetailsFiltersSchemaSuccess,
  GetReferralDetailsFiltersSchemaError,
  SetReferralDetailsReportToSave,
} from "@modules/reporting/constants/actions";
import type { ReferralDetailsState } from "./types";
import { cloneObject } from "@utils/object";

export const initialState: ReferralDetailsState = {
  error: null,
  requestsInProgress: 0,
  defaultReports: [],
  mySavedReports: [],
  currentReport: null,
  currentCharts: null,
  reportData: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  referralDetailsFiltersSchema: null,
  reportToSave: null,
};

export const setLoading = (state: ReferralDetailsState) => () => {
  return {
    ...state,
    requestsInProgress: ++state.requestsInProgress,
  };
};

export const onGetReportingReferralDetailsDefaultReportsSuccess = (
  state: ReferralDetailsState,
) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    defaultReports: payload,
  };
};

export const onGetReportingReferralDetailsReportSuccess = (state: ReferralDetailsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: null,
    reportData: payload,
  };
};

export const onGetReportingReferralDetailsReport = (state: ReferralDetailsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: null,
    currentReport: payload,
  };
};

export const onGetReportingReferralDetailsChartsSuccess = (state: ReferralDetailsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: null,
    currentCharts: payload,
  };
};

export const onGetReportingReferralDetailsMySavedReportsSuccess = (
  state: ReferralDetailsState,
) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    mySavedReports: payload,
  };
};

export const onGetReferralDetailsFiltersSchemaSuccess = (state: ReferralDetailsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: null,
    referralDetailsFiltersSchema: payload,
  };
};

export const onError = (state: ReferralDetailsState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
  };
};

export const onSetReferralDetailsReportToSave = (state: ReferralDetailsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    reportToSave: payload,
  };
};

export default (
  state: ReferralDetailsState = initialState,
  action: Object,
): ReferralDetailsState => {
  const act = {
    [GetReportingReferralDetailsDefaultReports]: setLoading,
    [GetReportingReferralDetailsDefaultReportsSuccess]: onGetReportingReferralDetailsDefaultReportsSuccess,
    [GetReportingReferralDetailsReport]: onGetReportingReferralDetailsReport,
    [GetReportingReferralDetailsReportSuccess]: onGetReportingReferralDetailsReportSuccess,
    [GetReportingReferralDetailsMyReports]: setLoading,
    [GetReportingReferralDetailsMyReportsSuccess]: onGetReportingReferralDetailsMySavedReportsSuccess,
    [GetReportingReferralDetailsChartsSuccess]: onGetReportingReferralDetailsChartsSuccess,
    [GetReportingReferralDetailsCharts]: setLoading,
    [GetReferralDetailsFiltersSchema]: setLoading,
    [GetReferralDetailsFiltersSchemaSuccess]: onGetReferralDetailsFiltersSchemaSuccess,
    [SetReferralDetailsReportToSave]: onSetReferralDetailsReportToSave,
    [GetReportingReferralDetailsDefaultReportsError]: onError,
    [GetReportingReferralDetailsReportError]: onError,
    [GetReportingReferralDetailsMyReportsError]: onError,
    [GetReportingReferralDetailsChartsError]: onError,
    [GetReferralDetailsFiltersSchemaError]: onError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
